{
  "labels": {
    "aircraft": "Aeronave",
    "limitToCompleted": "Limitar a completados",
    "limitToNotCompleted": "Limitar a no completados",
    "locked": "¿Bloqueado?",
    "isHidden": "¿Oculto?"
  },
  "buttons": {
    "new": "Novo",
    "deploy": "Desplegar"
  },
  "snackbar": {
    "staging": "FYI - Estás en staging",
    "editingCompleted": "Estás editando una aeronave completada.",
    "deploymentStarted": "Despliegue de datos de aeronaves iniciado. Sigue el progreso en Super Admin > pestaña Estado del Sistema.",
    "deploymentFailed": "Despliegue fallido"
  },
  "confirmations": {
    "lockToggle": "¿Estás seguro?",
    "hiddenToggle": "¿Estás seguro?",
    "deployTitle": "Confirmar despliegue",
    "deployText": "¿Seguro que deseas desplegar?",
    "deployOk": "¡Vamos!"
  },
  "errors": {
    "deployFailed": "Error al desplegar datos de aeronave"
  },
  "presenter": {
    "labels": {
      "topView": "Vista aérea",
      "sideView": "Vista lateral"
    },
    "buttons": {
      "removeImage": "eliminar imagen"
    }
  },
  "inputForm": {
    "labels": {
      "id": "ID",
      "make": "Crear",
      "model": "Modelo",
      "linkAircraftTo": "Vincular esta aeronave a",
      "wingBottom": "Ala inferior",
      "wingTop": "Ala superior",
      "horizontalTailBottom": "Estabilizador horizontal inferior —",
      "horizontalTailTop": "Estab. horizontal sup. —",
      "verticalTailBottom": "Cola vertical inferior |",
      "verticalTailTop": "Cola vertical superior |",
      "cabinBottom": "Cabina inferior",
      "cabinTop": "Techo cabina",
      "nose": "Nariz",
      "midline": "Centro",
      "length": "Longitud",
      "wingspan": "Envergadura",
      "tailHeight": "Altura de cola",
      "contourNumber": "Contorno n.º",
      "simplifyPercent": "Simplificar %",
      "bottom": "Inferior",
      "top": "Tope",
      "limitDegrees": "Limitar grados",
      "front": "Frontal",
      "rear": "Atrás",
      "tailWheel": "¿Rueda de cola?",
      "fuelCapacity": "Capacidad combust.",
      "fuelType": "Combustible",
      "cruiseBurn": "Consumo en crucero (gal/hr)",
      "cruiseSpeed": "Velocidad de crucero (kts)",
      "reserves": "Reservas (gal)",
      "cruiseAltitude": "Altitud de crucero (ft)",
      "isHelicopter": "¿Es helicóptero?"
    },
    "buttons": {
      "remove": "Eliminar",
      "save": "Guardar",
      "noPropeller": "sin hélice",
      "select": "Elegir",
      "clear": "Borrar",
      "auto": "auto"
    },
    "sections": {
      "referencePoints": "Puntos de referencia",
      "orientation": "Orientación",
      "propellers": "Hélices",
      "dimensions": "Dimensiones",
      "outline": "Esquema",
      "overlaps": "Traslapes",
      "wings": "Alas",
      "horizontalTail": "Cola horizontal",
      "verticalTailFin": "Estabilizador vertical",
      "cabin": "Cabina",
      "towing": "Remolque",
      "fuel": "Comb.",
      "helicopter": "Helicóptero"
    },
    "fuelTypes": {
      "jetA": "Jet A",
      "avGas": "AvGas",
      "other": "Otro"
    },
    "helperText": {
      "cruiseBurn": "Consumo típico de combustible en crucero en galones por hora",
      "cruiseSpeed": "Velocidad verdadera de crucero típica en nudos",
      "reserves": "Reservas de combustible típicas (alternado VFR/IFR + seguridad)",
      "cruiseAltitude": "Altitud de crucero típica en pies (ej., 41000 para FL410)"
    }
  }
}
